'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmChangePhone = undefined;

var _ConfirmChangePhone2 = require('./ConfirmChangePhone');

var _ConfirmChangePhone3 = _interopRequireDefault(_ConfirmChangePhone2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ConfirmChangePhone = _ConfirmChangePhone3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmChangePhone/index.js
// module id = 1645
// module chunks = 0